var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { RemoteJobRunStatus, RemoteJobStatus } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import { useRemoteJobActions, useRemoteJobRunsByRemoteJobId, useRemoteJobs } from '@data/hooks/remoteJobs';
import ManagerLayout from '@main/conf/managers/ManagerLayout';
import BorderdContainer from '@main/conf/managers/BorderedContainer';
import FSButton from '@components/FSButton';
import FormInput from '@shared/forms/FormInput';
import List from '@shared/List';
import { Status } from '@shared/status/status';
import { appColors } from '../../styled/useTheme';
var TITLE_TEXT = {
    color: appColors.ui.dark,
    fontSize: 16,
    fontWeight: 800,
    marginBottom: 8,
    userSelect: 'none',
    cursor: 'pointer',
};
var MUTED_TEXT = {
    color: appColors.neutral.w700,
    fontSize: 12,
};
var STATUS_STYLE_MAP = (_a = {},
    _a[RemoteJobRunStatus.QUEUED] = {
        fontSize: 11,
        padding: '4px 8px',
        fontWeight: 700,
        backgroundColor: appColors.neutral.w200,
        color: appColors.neutral.w700,
    },
    _a[RemoteJobRunStatus.RUNNING] = {
        fontSize: 11,
        padding: '4px 8px',
        fontWeight: 700,
        backgroundColor: appColors.ui.dark,
        color: appColors.ui.white,
    },
    _a[RemoteJobRunStatus.FINISHED] = {
        fontSize: 11,
        padding: '4px 8px',
        fontWeight: 700,
        backgroundColor: appColors.success.w50,
        color: appColors.success.w500,
    },
    _a[RemoteJobRunStatus.ERROR] = {
        fontSize: 11,
        padding: '4px 8px',
        fontWeight: 700,
        backgroundColor: appColors.error.w50,
        color: appColors.error.w500,
    },
    _a);
function ListItemTitle(_a) {
    var icon = _a.icon, title = _a.title, status = _a.status, onClick = _a.onClick;
    return (React.createElement("div", { onClick: onClick, style: TITLE_TEXT },
        icon && React.createElement("span", null,
            icon,
            " "),
        " ",
        title,
        ' ',
        status && React.createElement(Status, { status: status, value: status, style: STATUS_STYLE_MAP[status] })));
}
function ScheduledText(_a) {
    var schedule = _a.schedule;
    var L = useLanguage().L;
    var infoText = '';
    if (/^\*\/[0-9]{1,2} \* \* \* \*$/.test(schedule)) {
        infoText = "".concat(L('Every'), " ").concat(schedule.replace('*/', '').replace(/\s\*/g, ''), " ").concat(L('minutes'));
    }
    else if (/^0\/[0-9]{1,2} \* \* \* \*$/.test(schedule)) {
        infoText = "".concat(L('Every'), " ").concat(schedule.replace('0/', '').replace(/\s\*/g, ''), "th minute");
    }
    else if (/^[0-9]{1,2} \* \* \* \*$/.test(schedule)) {
        infoText = "".concat(L('Every hour at'), " ").concat(schedule.replace(/\s\*/g, ''));
    }
    else if (/^[0-9]{1,2} [0-9]{1,2} \* \* \*$/.test(schedule)) {
        var timeInfo = schedule.replace(/\s\*/g, '').split(' ');
        infoText = "".concat(L('Every day at'), " ").concat(timeInfo[1].length === 1 ? '0' : '').concat(timeInfo[1], ":").concat(timeInfo[0].length === 1 ? '0' : '').concat(timeInfo[0]);
    }
    else if (/^[0-9]{1,2} [0-9]{1,2} \* \* [0-7]$/.test(schedule)) {
        var timeInfo = schedule.replace(/\s\*/g, '').split(' ');
        var dayOfWeek = Number.parseInt(schedule.replace(/[0-9]{1,2} [0-9]{1,2}/, '').replace(/\s\*/g, ''));
        var dayOfWeekText = '';
        switch (dayOfWeek) {
            case 0:
            case 7: {
                dayOfWeekText = 'sunday';
                break;
            }
            case 1: {
                dayOfWeekText = 'monday';
                break;
            }
            case 2: {
                dayOfWeekText = 'tuesday';
                break;
            }
            case 3: {
                dayOfWeekText = 'wednesday';
                break;
            }
            case 4: {
                dayOfWeekText = 'thursday';
                break;
            }
            case 5: {
                dayOfWeekText = 'friday';
                break;
            }
            case 6: {
                dayOfWeekText = 'saturday';
                break;
            }
        }
        infoText = "".concat(L('Every week'), " ").concat(L('on a'), " ").concat(L(dayOfWeekText), " ").concat(L('at'), " ").concat(timeInfo[1].length === 1 ? '0' : '').concat(timeInfo[1], ":").concat(timeInfo[0].length === 1 ? '0' : '').concat(timeInfo[0]);
    }
    else if (schedule !== '') {
        infoText = "".concat(L('Scheduled'), ": ").concat(schedule);
    }
    return React.createElement("span", { style: MUTED_TEXT }, infoText);
}
function RunJobButton(_a) {
    var remoteJob = _a.remoteJob, onClick = _a.onClick;
    var L = useLanguage().L;
    if (remoteJob.status === RemoteJobStatus.AVAILABLE) {
        return React.createElement(FSButton, { title: L('Run Job'), onClick: onClick });
    }
    else if (remoteJob.status === RemoteJobStatus.QUEUED) {
        return React.createElement(FSButton, { title: L('Queued'), disabled: true });
    }
    else if (remoteJob.status === RemoteJobStatus.RUNNING) {
        return React.createElement(FSButton, { title: L('Running...'), disabled: true });
    }
    else {
        return React.createElement(FSButton, { title: L('Unavailable'), disabled: true });
    }
}
function RemoteJobsTab(_a) {
    var selectedRemoteJobId = _a.selectedRemoteJobId, setSelectedRemoteJobId = _a.setSelectedRemoteJobId;
    var L = useLanguage().L;
    var remoteJobs = useRemoteJobs();
    var _b = useRemoteJobActions(), removeRemoteJob = _b.removeRemoteJob, runRemoteJob = _b.runRemoteJob;
    var _c = __read(useState([]), 2), jobArguments = _c[0], setJobArguments = _c[1];
    var renderRemoteJob = function (remoteJob, index) {
        var _a;
        var thisRemoteJobSelected = remoteJob.id === selectedRemoteJobId;
        var thisRemoteJobStyle = {
            padding: '1em',
            borderTop: '1px solid ' + appColors.neutral.w200,
        };
        if (index === 0) {
            delete thisRemoteJobStyle.borderTop;
        }
        if (thisRemoteJobSelected) {
            thisRemoteJobStyle.backgroundColor = appColors.neutral.w50;
        }
        return (React.createElement("div", { key: "remoteJob_".concat(remoteJob.id), onClick: function () { return setSelectedRemoteJobId(remoteJob.id); }, style: thisRemoteJobStyle },
            React.createElement(ListItemTitle, { title: remoteJob.name }),
            React.createElement("p", { style: MUTED_TEXT }, remoteJob.description),
            remoteJob.expectedArguments.map(function (arg, argIdx) {
                var _a, _b;
                return (React.createElement(FormInput, { key: "remoteJob_".concat(remoteJob.id, "_argument_").concat(argIdx), label: arg.substring(0, 1).toUpperCase() + arg.substring(1), name: arg.toLowerCase(), type: /password/.test(arg) ? 'password' : 'text', value: (_b = (_a = jobArguments[remoteJob.id]) === null || _a === void 0 ? void 0 : _a[argIdx]) !== null && _b !== void 0 ? _b : '', whiteBg: thisRemoteJobSelected, onChange: function (e) {
                        var _a;
                        var thisJobArgumentsCopy = __spreadArray([], __read(((_a = jobArguments[remoteJob.id]) !== null && _a !== void 0 ? _a : [])), false);
                        thisJobArgumentsCopy[argIdx] = e.target.value;
                        var jobArgumentsCopy = __spreadArray([], __read(jobArguments), false);
                        jobArgumentsCopy[remoteJob.id] = thisJobArgumentsCopy;
                        setJobArguments(jobArgumentsCopy);
                    } }));
            }),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                } },
                React.createElement(ScheduledText, { schedule: (_a = remoteJob.schedule) !== null && _a !== void 0 ? _a : '' }),
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'nowrap',
                        justifyContent: 'flex-end',
                    } },
                    remoteJob.status === RemoteJobStatus.UNAVAILABLE && (React.createElement(FSButton, { "$color": "error", title: L('Delete'), onClick: function () { return removeRemoteJob(remoteJob.id); } })),
                    React.createElement(RunJobButton, { remoteJob: remoteJob, onClick: function () {
                            var _a;
                            return toast.promise(runRemoteJob({
                                remoteJobId: remoteJob.id,
                                jobArguments: (_a = jobArguments[remoteJob.id]) !== null && _a !== void 0 ? _a : [],
                            }), {
                                loading: 'Queuing job',
                                error: 'Error queuing job',
                                success: 'Job queued',
                            });
                        } })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, L('Jobs')),
        React.createElement(BorderdContainer, { style: { borderColor: appColors.neutral.w200 } },
            React.createElement(List, { items: remoteJobs, renderItem: renderRemoteJob }))));
}
function RemoteJobRunsTab(_a) {
    var selectedRemoteJobId = _a.selectedRemoteJobId;
    var L = useLanguage().L;
    var remoteJobRuns = useRemoteJobRunsByRemoteJobId(selectedRemoteJobId);
    var _b = __read(useState([]), 2), expandedRemoteJobRunIds = _b[0], setExpandedRemoteJobRunIds = _b[1];
    var renderRemoteJobRun = function (remoteJobRun, index) {
        var thisRunExpanded = expandedRemoteJobRunIds.includes(remoteJobRun.id);
        return (React.createElement("div", { key: "remoteJobRun_".concat(remoteJobRun.id) },
            React.createElement(ListItemTitle, { icon: thisRunExpanded ? '-' : '+', title: remoteJobRun.startedAt.toLocaleString('hr-HR'), status: remoteJobRun.status, onClick: function () {
                    if (thisRunExpanded) {
                        var expandedRemoteJobRunIdsCopy = expandedRemoteJobRunIds.filter(function (id) { return id !== remoteJobRun.id; });
                        setExpandedRemoteJobRunIds(expandedRemoteJobRunIdsCopy);
                    }
                    else {
                        var expandedRemoteJobRunIdsCopy = __spreadArray([], __read(expandedRemoteJobRunIds), false);
                        expandedRemoteJobRunIdsCopy.push(remoteJobRun.id);
                        setExpandedRemoteJobRunIds(expandedRemoteJobRunIdsCopy);
                    }
                } }),
            thisRunExpanded && (React.createElement("div", { style: __assign(__assign({}, MUTED_TEXT), { paddingLeft: '1em' }) },
                React.createElement("p", null,
                    "UUID: ",
                    remoteJobRun.uuid),
                remoteJobRun.logs.map(function (log, logIdx) { return (React.createElement("p", { key: "remoteJobRun_".concat(remoteJobRun.id, "_log_").concat(logIdx) }, log)); })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, L('Job Logs')),
        React.createElement(BorderdContainer, { style: { borderColor: appColors.neutral.w200 } },
            React.createElement(List, { items: remoteJobRuns, renderItem: renderRemoteJobRun, style: { padding: 15 }, gap: 8 }))));
}
function RemoteJobs() {
    var L = useLanguage().L;
    var _a = __read(useState(0), 2), selectedRemoteJobId = _a[0], setSelectedRemoteJobId = _a[1];
    var contentLeft = (React.createElement(RemoteJobsTab, { selectedRemoteJobId: selectedRemoteJobId, setSelectedRemoteJobId: setSelectedRemoteJobId }));
    var contentRight = React.createElement(RemoteJobRunsTab, { selectedRemoteJobId: selectedRemoteJobId });
    return React.createElement(ManagerLayout, { title: L('Remote Jobs'), contentLeft: contentLeft, contentRight: contentRight });
}
export default RemoteJobs;
